/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProductListAliases {
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  HPMS_PRODUCT_CUSTOM_LINK = 'hpms-product-custom-link',
  PANEL_PRODUCTS = 'panel-products',
}
export { ProductListAliases };
